import * as React from 'react';
import { Button, Modal, RichTextArea } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import { useCmsData } from '../../../../../context/CmsContext.js';

const ContactLensesRxInfoModal = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { contactLensesInfoModal  } = useCmsData();
    const [isOpen, setIsOpen] = React.useState(false);
    if (!contactLensesInfoModal) {
        return null;
    }
    const openModal = ()=>setIsOpen(true)
    ;
    const closeModal = ()=>setIsOpen(false)
    ;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        className: className,
        variant: "ghost",
        onClick: openModal,
        caption: getLabel('products.contactLenses.prescription.link')
    }), /*#__PURE__*/ React.createElement(Modal, {
        showIcon: true,
        isOpen: isOpen,
        onModalClose: closeModal
    }, /*#__PURE__*/ React.createElement("div", {
        className: "contact-lenses-rx-info__modal"
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: contactLensesInfoModal
    }))));
};

export { ContactLensesRxInfoModal };
//# sourceMappingURL=ContactLensesRxInfoModal.js.map
